export default __webpack_public_path__ + "media/images/kitchen-fabfdb71791bbe13366db15b3b20eb3c.jpg";